var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShape(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.167 15c0 7.823-6.343 14.167-14.167 14.167C7.177 29.167.833 22.823.833 15 .833 7.176 7.177.833 15 .833 22.824.833 29.167 7.176 29.167 15z",
    fill: "#F7B500"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIHZpZXdCb3g9IjAgMCAzMCAzMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yOS4xNjY4IDE1QzI5LjE2NjggMjIuODIzNSAyMi44MjM3IDI5LjE2NjYgMTUuMDAwMiAyOS4xNjY2QzcuMTc2NjIgMjkuMTY2NiAwLjgzMzQ5NiAyMi44MjM1IDAuODMzNDk2IDE1QzAuODMzNDk2IDcuMTc2NDQgNy4xNzY2MiAwLjgzMzMxMyAxNS4wMDAyIDAuODMzMzEzQzIyLjgyMzcgMC44MzMzMTMgMjkuMTY2OCA3LjE3NjQ0IDI5LjE2NjggMTVaIiBmaWxsPSIjRjdCNTAwIi8+Cjwvc3ZnPgo=";
export { SvgShape as ReactComponent };